import {FormGroup} from '@angular/forms';
import 'moment/locale/ar-sa';
import 'moment/locale/en-au';

import {secureStorage} from "./secure-storage";
import moment from "moment";
import Hls from 'hls.js';
import {datePipe, momentDateFormat} from "../variables/variables";

export function GetLanguage() {
  return (secureStorage.getItem('lang') || 'ar');
}

export function GetPreferredDate() {
  return secureStorage.getItem('userProfile')?.preferred_date?.toString();
}

export function GetCurrentUser() {
  return secureStorage.getItem('userProfile');
}

export function HandleListName(list) {
  list?.forEach(item => item.name = GetLanguage() === 'ar' ? (item.name_ar || item.nameAr) : (item.name_en || item.name))
  return list;
}

export function HandleListTitle(list) {
  list?.forEach(item => item.name = GetLanguage() === 'ar' ? item.title_ar : item.title_en)
  return list;
}

export function HandleObjName(obj) {
  if (obj) {
    obj.name = GetLanguage() === 'ar' ? obj?.name_ar : obj?.name_en
    return obj;
  }
  return;
}

export function GetDeviceInfoFromIPAddress() {
  // https://dashboard.ipregistry.co/keys
  fetch('https://api.ipregistry.co/?key=jn67t3hw1svfhqjr')
    .then(function (response) {
      return response.json();
    })
    .then(function (payload) {
      secureStorage.setItem('location', {
        country: payload?.location?.country?.name,
        city: payload?.location?.city
      })
    });
}

export function HandleResponseError(error) {
  return (error?.error?.error ? error?.error?.error : error?.error?.message);
}

export function ConfirmedValidator(controlName: string, matchingControlName: string) {
  return (formGroup: FormGroup) => {
    const control = formGroup.controls[controlName];
    const matchingControl = formGroup.controls[matchingControlName];
    if (matchingControl.errors && !matchingControl.errors['confirmedValidator']) {
      return;
    }
    if (control.value !== matchingControl.value) {
      matchingControl.setErrors({confirmedValidator: true});
    } else {
      matchingControl.setErrors(null);
    }
  }
}

export function ReloadCurrentComponent(router) {
  // https://www.codegrepper.com/code-examples/typescript/How+to+Reload+a+Component+in+Angular
  const currentUrl = router.url;
  router.routeReuseStrategy.shouldReuseRoute = () => false;
  router.onSameUrlNavigation = 'reload';
  router.navigate([currentUrl]);
}

export function searchInAllTableColumns(filterColumns, backup): any {
  return backup.filter(item => {
    for (let i = 0; i < filterColumns.length; i++) {
      var check = false;
      if (item[filterColumns[i]?.type] && (item[filterColumns[i]?.type]?.toString().trim().toLowerCase()
        .indexOf(filterColumns[i]?.value?.trim().toLowerCase()) !== -1)) {
        check = true;
      } else {
        return false;
      }
      if (i === filterColumns.length - 1) {
        return check
      }
    }
  })
}

export function filterTable(e, backup) {
  // console.log('e', e);
  let loopedArr;
  let data = backup;
  if (e?.sites?.length) {
    loopedArr = e.sites;
    data = loopOverFilter(loopedArr, 'site', data);
  }
  if (e?.departments?.length) {
    loopedArr = e.departments;
    data = loopOverFilter(loopedArr, 'department', data);
  }
  if (e?.individuals?.length) {
    loopedArr = e.individuals;
    data = loopOverFilter(loopedArr, 'employee', data);
  }
  if (e?.roles?.length) {
    loopedArr = e.roles;
    data = loopOverFilter(loopedArr, 'role', data);
  }
  if (e?.reportTypes?.length) {
    loopedArr = e.reportTypes;
    data = loopOverFilter(loopedArr, 'type', data);
  }
  if (e?.requestsStatus?.length) {
    loopedArr = e.requestsStatus;
    data = loopOverFilter(loopedArr, 'status', data);
  }
  if (e?.paw) {
    data = data.filter(x => x.PAW === e.paw);
    // console.log('paw', data)
  }
  return data
}

export function setMomentLocal() {
  moment.locale(GetLanguage() === 'ar' ? (GetPreferredDate() === '1' ? 'en-US' : 'en-US') : 'en-GB');
}


function loopOverFilter(loopedArr, column, backup?) {
  let filtered = [];
  for (let i = 0; i < loopedArr.length; i++) {
    if (loopedArr[i]?.name?.trim().toLowerCase() === 'all') {
      return backup;
    }
    let batch = backup.filter(x => x[column]?.toString().trim().toLowerCase() === loopedArr[i]?.name?.trim().toLowerCase());
    batch?.forEach(one => {
      if (filtered.findIndex(x => x === one) === -1) {
        filtered.push(one);
      }
    })
  }
  return filtered;
}

export function AcceptEnglish(obj) {
  const event = obj.event;
  const pastedText = event.clipboardData?.getData('text');
  const code = pastedText ? pastedText?.charCodeAt(0) : event?.keyCode;
  const code2 = pastedText?.charCodeAt(1);
  const code3 = pastedText?.charCodeAt(6);
  const code4 = pastedText?.charCodeAt(12);
  const code5 = pastedText?.charCodeAt(17);
  if (
    (code >= 1536 && code <= 1791) ||
    (code2 >= 1536 && code2 <= 1791) ||
    (code3 >= 1536 && code3 <= 1791) ||
    (code4 >= 1536 && code4 <= 1791) ||
    (code5 >= 1536 && code5 <= 1791)
  ) {
    event.preventDefault();
    secureStorage.setItem('ArabicInEnglish', 'Please enter only english text.');
    if (!obj.control?.value) {
      obj.control.setErrors({wrong_text: true});
    }
  } else {
    secureStorage.removeItem('ArabicInEnglish');
    obj.control.setErrors(null);
  }
}

export function AcceptArabic(obj) {
  const event = obj.event;
  const pastedText = event.clipboardData?.getData('text');
  const code = pastedText ? pastedText?.charCodeAt(0) : event?.keyCode;
  const code2 = pastedText?.charCodeAt(1);
  const code3 = pastedText?.charCodeAt(6);
  const code4 = pastedText?.charCodeAt(12);
  const code5 = pastedText?.charCodeAt(17);
  if (
    (code >= 65 && code <= 90) || (code >= 97 && code <= 122) ||
    (code2 >= 65 && code2 <= 90) || (code2 >= 97 && code2 <= 122) ||
    (code3 >= 65 && code3 <= 90) || (code3 >= 97 && code3 <= 122) ||
    (code4 >= 65 && code4 <= 90) || (code4 >= 97 && code4 <= 122) ||
    (code5 >= 65 && code5 <= 90) || (code5 >= 97 && code5 <= 122)

  ) {
    event.preventDefault();
    secureStorage.setItem('EnglishInArabic', 'Please enter only arabic text.');
    if (!obj.control?.value) {
      obj.control.setErrors({wrong_text: true});
    }
  } else {
    secureStorage.removeItem('EnglishInArabic');
    obj.control.setErrors(null);
  }
}

export function formatTimeFromString(value, format?) {
  if (value) {
    return moment(value, [moment.ISO_8601, 'HH:mm'])
  }
}

export function PlayM3u8(row, el, translate) {
  let m3u8Source;
  const values = [];
  const labels = [];
  if (row?.student) {
    labels.push(constructObject('student_label', translate.instant('STUDENT')));
    values.push(constructObject('student_name', row.student || '-'));
  }
  if (row?.status) {
    values.push(constructObject('status', row?.status));
    labels.push(constructObject('status_label', translate.instant('Status')));
  }
  if (row?.teacher_rate) {
    values.push(constructObject('teacher_rate', row?.teacher_rate ?? '-'));
    labels.push(constructObject('teacher_rate_label', translate.instant('Teacher Rate')));
  }
  if (row?.student_rate) {
    values.push(constructObject('student_rate', row?.student_rate ?? '-'));
    labels.push(constructObject('student_rate_label', translate.instant('Student Rate')));
  }
  labels.push(constructObject('teacher_label', translate.instant('TEACHER')));
  labels.push(constructObject('created_at_label', translate.instant('Created At')));
  //////////////////////////////
  values.push(constructObject('teacher_name', row.teacher || '-'));
  values.push(constructObject('created_at', momentDateFormat(row?.created_at) || '-'));

  //////////////////////////////
  const newWindow = window.open('', "_blank", "height=800,width=650,left=600,top=200");
  newWindow.document.write(`
    <div style="display: flex;
    justify-content: center;
    align-content: center;
    flex-direction: column;
    box-sizing: border-box;
    font-family: 'helvetica_custom', 'arial', sans-serif !important;
    flex-wrap: wrap;">
   <img style="width: 200px; margin: 10px auto" src="" alt="cib">
    <video #video id="video" width="600" height="500" controls></video>
    <div style="display: flex;
    margin-top: 10px;
    align-content: center;
    flex-direction: row;
    box-sizing: border-box;
    flex-wrap: wrap;">
     <div style="display: flex; flex-direction: column;">
       <div style="display: flex; flex-direction: column; margin-bottom: 10px;">
        <span style="font-weight: bold;font-size: 15px" id="teacher_label"></span>
        <span style="margin-top: 5px" id="teacher_name"></span>
       </div>
       <div style="display: flex; flex-direction: column; margin-bottom: 10px;">
        <span style="font-weight: bold;font-size: 15px" id="created_at_label"></span>
        <span style="margin-top: 5px" id="created_at"></span>
     </div>
       <div style="display: flex; flex-direction: column; margin-bottom: 10px;">
      <span style="font-weight: bold;font-size: 15px" id="teacher_rate_label"></span>
      <span style="margin-top: 5px" id="teacher_rate"></span>
     </div>
   </div>
     <div style="display: flex; flex-direction: column; margin-left: 200px">
     <div style="display: flex; flex-direction: column; margin-bottom: 10px;">
          <span style="font-weight: bold;font-size: 15px" id="student_label"></span>
          <span style="margin-top: 5px" id="student_name"></span>
       </div>
     <div style="display: flex; flex-direction: column; margin-bottom: 10px;">
        <span style="font-weight: bold;font-size: 15px" id="status_label"></span>
        <span style="margin-top: 5px" id="status"></span>
      </div>
     <div style="display: flex; flex-direction: column; margin-bottom: 10px;">
      <span style="font-weight: bold;font-size: 15px" id="student_rate_label"></span>
      <span style="margin-top: 5px" id="student_rate"></span>
     </div>
    </div>
    </div>
   </div>
    `);
  for (let i = 0; i < labels.length; i++) {
    newWindow.document.getElementById(Object.keys(labels[i])[0]).innerText = String(Object.values(labels[i])[0]);
  }
  for (let i = 0; i < values.length; i++) {
    newWindow.document.getElementById(Object.keys(values[i])[0]).innerText = String(Object.values(values[i])[0]);
  }
  // newWindow.document.getElementById('student_label').innerText = student_label;
  // newWindow.document.getElementById('teacher_label').innerText = teacher_label;
  // newWindow.document.getElementById('status_label').innerText = status_label;
  // newWindow.document.getElementById('created_at_label').innerText = created_at_label;
  // newWindow.document.getElementById('teacher_rate_label').innerText = teacher_rate_label;
  // newWindow.document.getElementById('student_rate_label').innerText = student_rate_label;
  // ///////////////////
  // newWindow.document.getElementById('teacher_name').innerText = teacher;
  // newWindow.document.getElementById('student_name').innerText = student;
  // newWindow.document.getElementById('status').innerText = status;
  // newWindow.document.getElementById('created_at').innerText = created_at;
  // newWindow.document.getElementById('teacher_rate').innerText = teacher_rate;
  // newWindow.document.getElementById('student_rate').innerText = student_rate;
  m3u8Source = row?.record_url ? row?.record_url : row?.video_url ? row?.video_url : row?.session?.record_url;
  const element = el.nativeElement.querySelector('video');
  const video: any = newWindow.document.getElementById("video");
  if (Hls.isSupported()) {
    var hls = new Hls();
    hls.loadSource(m3u8Source);
    hls.attachMedia(video);
  } else if (video.canPlayType('application/vnd.apple.mpegurl')) {
    video.src = m3u8Source;
  }
  hls.on(Hls.Events.MANIFEST_PARSED, () => {
    // video.play();
  });
}

function constructObject(key, value) {
  let obj = {};
  obj[key] = value;
  return obj;
}

export function downloadPdfFileFromUrl(name, FileSaver, path, contentType) {
  const xhr = new XMLHttpRequest();
  // console.log(path)
  xhr.onreadystatechange = function () {
    if (this.readyState === 4 && this.status === 200) {
      const fileOfBlob = new File([this.response], name, {type: contentType});
      FileSaver.saveAs(fileOfBlob);
    }
  };
  xhr.open('GET', path);
  xhr.responseType = 'blob';
  xhr.send();
}
export function downloadFromBlobResponse(res, type, name) {
  const blob = new Blob([res], {type: type});
  const link = document.createElement('a');
  if (link.download !== undefined) {
    // Browsers that support HTML5 download attribute
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute('download', name);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
}

export function CopyMessage(val: string, toastr, translateService) {
  val = new DOMParser().parseFromString(val, 'text/html').documentElement.textContent;
  const selBox = document.createElement('textarea');
  selBox.style.position = 'fixed';
  selBox.style.left = '0';
  selBox.style.top = '0';
  selBox.style.opacity = '0';
  selBox.value = val;
  document.body.appendChild(selBox);
  selBox.focus();
  selBox.select();
  document.execCommand('copy');
  document.body.removeChild(selBox);
  toastr.success(translateService.instant('Copied to clipboard'))
}

export function getDropdownSettings(translate) {
  return {
    singleSelection: false,
    idField: 'id',
    textField: 'name',
    selectAllText: translate.instant('Select all'),
    unSelectAllText: translate.instant('UnSelect all'),
    itemsShowLimit: 3,
    allowSearchFilter: true,
    clearSearchFilter: true,
    searchPlaceholderText: translate.instant('Search ..'),
    noDataAvailablePlaceholderText: translate.instant('No data available'),
    noFilteredDataAvailablePlaceholderText: translate.instant('No filtered data available'),
  }
}

export function prepareServerDate(date) {
  if (date) {
    return datePipe.transform(new Date(date), 'yyyy-MM-dd');
  } else {
    return null;
  }
}
